import { PollResult } from '@queries/getPoll';
import React from 'react';
import {
  Percentage,
  PollOptionLabel,
  PollOptionsContainer,
  Row,
} from './styles';

type Props = {
  pollResults: PollResult[];
};

const PollResultsRenderer = ({ pollResults }: Props) => {
  return (
    <PollOptionsContainer>
      {pollResults.map(({ documentId, option, percentage, votes }) => (
        <Row key={documentId}>
          <PollOptionLabel>
            {option} ({percentage?.toFixed(0) || 0}% - {votes} votes)
          </PollOptionLabel>
          <Percentage percentage={percentage} />
        </Row>
      ))}
    </PollOptionsContainer>
  );
};

export default PollResultsRenderer;
